import $ from 'jquery';
import Swiper from 'swiper';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/carousel'
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/modal';
import 'slick-carousel/slick/slick';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

const hamuAnime = () => {
  const hamuBtn = document.querySelector('#hamuMenu');
  const spmenuBtn = document.querySelector('#sp-menu');
  const toggleClass = 'is_set';

  hamuBtn.addEventListener('click', () => {
    if (hamuBtn.classList.contains(toggleClass)) {
      hamuBtn.classList.remove(toggleClass);
      spmenuBtn.classList.remove(toggleClass);

    } else {
      hamuBtn.classList.add(toggleClass);
      spmenuBtn.classList.add(toggleClass);
    }
  })
}

const headerMarginAuto = () => {
  let h = $('#header').innerHeight();
  $('.hma').css('margin-top', h);
  $('.hpa').css('padding-top', h);
}


const worksSlide = () => {
  const swiper = new Swiper('.swiper-container', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true,
    speed: 500,
    slidesPerView: 3,
    centeredSlides: true,
    breakpoints: {
      // 画面幅が 767px 以上の場合
      767: {
        slidesPerView: 1.2,
      },
    },
  });
}

const singleWorksSlide = () => {

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.slider-nav',
  });
  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: false,
    responsive: [{
      breakpoint: 1200,
      settings: {
        centerPadding: '10%',
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToScroll: 1,
        centerPadding: '0%',
      }
    }
    ]
  });

}

const catAreaCtrl = () => {
  const btn = document.querySelector('#btnCategory');
  const toggleClass = 'is_set';

  if (btn) {
    btn.addEventListener('click', () => {
      $('#cat-area').slideToggle(300);
    })
  }
}

const faqSlide = () => {
  const faqContents = document.querySelectorAll('.faqContents');
  const faqContentsArr = Array.prototype.slice.call(faqContents);

  faqContentsArr.forEach((btn, index) => {
    btn.addEventListener('click', () => {

      $(btn).next('.accordion-content').slideToggle(500);

      if (btn.classList.contains('is_set')) {
        btn.classList.remove('is_set');
      } else {
        btn.classList.add('is_set');
      }

    })
  })
}

const fadeAnime = () => {

  gsap.set(".fadeRightTrigger", { opacity: 0, x: 50 }); //初期状態をセット
  ScrollTrigger.batch(".fadeRightTrigger", {
    onEnter: batch => gsap.to(batch, {
      opacity: 1,
      duration: 1.5,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: 'circ.out',
      overwrite: 'auto',
    }),
    start: 'top 80%',
    once: true,
  })

  gsap.set(".fadeLeftTrigger", { opacity: 0, x: -50 }); //初期状態をセット
  ScrollTrigger.batch(".fadeLeftTrigger", {
    onEnter: batch => gsap.to(batch, {
      opacity: 1,
      duration: 1.5,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: 'circ.out',
      overwrite: 'auto',
    }),
    start: 'top 80%',
    once: true,
  })


  gsap.set(".fadeDownTrigger", { opacity: 0, y: 100 }); //初期状態をセット
  ScrollTrigger.batch(".fadeDownTrigger", {
    onEnter: batch => gsap.to(batch, {
      opacity: 1,
      duration: 1.5,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: 'circ.out',
      overwrite: 'auto',
    }),
    start: "top 80%",
    once: true,
  });

  gsap.set(".fadeUpTrigger", { opacity: 0, y: 0 }); //初期状態をセット
  ScrollTrigger.batch(".fadeUpTrigger", {
    onEnter: batch => gsap.to(batch, {
      opacity: 1,
      duration: 1.5,
      x: 0,
      y: 100,
      autoAlpha: 1,
      ease: 'circ.out',
      overwrite: 'auto',
    }),
    start: "top 80%",
    once: true,
  });

  gsap.set(".sectionContentFloat", { opacity: 0, y: 0 }); //初期状態をセット
  ScrollTrigger.batch(".sectionContentFloat", {
    onEnter: batch => gsap.to(batch, {
      duration: 2,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: 'circ.out',
      overwrite: 'auto',
    }),
    start: "top 80%",
    once: true,
  });


}

// スムーススクロール
const smoothScroll = () => {
  $('.js-smooth').on('click', function (ev) {
    let navHeight = $('header').innerHeight();
    // prevent default click event
    ev.preventDefault();
    // get the scroll-to target
    let targetSection = $(this).attr('href');
    // get vertical offset of target
    let targetOffset = $(targetSection).offset().top;
    // scroll to the starget section
    gsap.to(window, 2, {
      scrollTo: { y: targetOffset - navHeight * 1.25 },
      ease: 'power4.out',
    });
  });
};

$(() => {
  hamuAnime();
  headerMarginAuto();
  worksSlide();
  singleWorksSlide();
  catAreaCtrl();
  faqSlide();
  smoothScroll();
  fadeAnime();
});

$(window).on('resize', () => {
  headerMarginAuto()
})